import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { tasksRouteNames } from '@/routes/constants/location'

const TasksPage = () => import('@/pmd/pages/tasks/Tasks.vue')

export const tasksRoute: RouteConfig[] = [
  {
    path: 'tasks',
    name: tasksRouteNames.default,
    component: TasksPage,
    meta: { translations: [Modules.Task] },
  },
]
